//This was pulled from pubweb-react-components and placed into a separte directory to
//not conflict with the Studio PostCard component
import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import Heading from '../../Typography/Heading';
import Bookmark from '../../Bookmark/Bookmark';

import PostCardStyles from './PostCard.styled';

const PostCard = ({
  image,
  imageAltText,
  category,
  tag,
  title,
  isBookmarked,
  onBookmarkClick,
  largeCard = false,
  showImage = true,
  bookmarkPlacement = 'top',
}) => {
  return (
    <PostCardStyles
      largeCard={largeCard}
      showImage={showImage}
      bookmarkPlacement={bookmarkPlacement}
    >
      <div className="post-image-container">
        <Image
          src={image}
          alt={imageAltText}
          className="post-image"
          width={233}
          height={170}
        />
      </div>
      <div className="post-card-info">
        <Bookmark
          bookmarkSVGWidth="17"
          bookmarkSVGHeight="21"
          isBookmarked={isBookmarked}
          onBookmarkClick={onBookmarkClick}
          placement={bookmarkPlacement}
        />
        <p className="category-tag">
          {category} | {tag}
        </p>
        <Heading headingSize="small" headingTag="h4">
          {title}
        </Heading>
      </div>
    </PostCardStyles>
  );
};

PostCard.propTypes = {
  bookmarkPlacement: PropTypes.string,
  category: PropTypes.any,
  image: PropTypes.any,
  imageAltText: PropTypes.any,
  isBookmarked: PropTypes.any,
  largeCard: PropTypes.bool,
  onBookmarkClick: PropTypes.any,
  showImage: PropTypes.bool,
  tag: PropTypes.any,
  title: PropTypes.any,
};

export default PostCard;
